import { useCallback } from 'react';

import { useAnalyticsUtilities } from '../hooks/useAnalyticsUtilities';
import META from './useTrackCreativePerformanceDateRangeAdjusted.meta';

export const useTrackCreativePerformanceDateRangeAdjusted = () => {
  const { track } = useAnalyticsUtilities();

  const trackCreativePerformanceDateRangeAdjusted = useCallback(() => {
    track(META.name);
  }, [track]);

  return { trackCreativePerformanceDateRangeAdjusted };
};
